import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customers-view',
  templateUrl: './customers-view.component.html',
  styleUrls: ['./customers-view.component.scss']
})
export class CustomersViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
